/**
 * Takes a dict object of string -> string and makes a reversed dict
 * from it.
 */
export function makeInvertedDict(dict: { [key: string]: string }): {
  [key: string]: string;
} {
  const reverseDict: { [key: string]: string } = {};
  for (const key of Object.keys(dict)) {
    reverseDict[dict[key]] = key;
  }
  return reverseDict;
}
